import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { ReservationLiveClassDateAndTime } from '../../components/ReservationLiveClassDateAndTime';
import { Button } from '../Button';
import { LiveClassTag } from '../LiveClassTag';
import { ModalReservationCancel } from '../ModalReservationCancel';
import { CountdownWidgetContent } from './CountdownWidgetContent';
import { WidgetLiveClass } from './WidgetLiveClass.type';

export interface CountdownWidgetStateClassLaterProps {
  liveClass: WidgetLiveClass;
}

export const CountdownWidgetStateClassLater = ({
  liveClass,
}: CountdownWidgetStateClassLaterProps) => {
  const __ = useTranslation().t;

  const [isModalReservationCancelActive, setIsModalReservationCancelActive] =
    useState<boolean>(false);

  const hasPreClassActivities = (liveClass.preClassActivities?.length || 0) > 0;

  return (
    <>
      <LiveClassTag type={liveClass.type} />
      <Title>{liveClass.title}</Title>
      <ReservationLiveClassDateAndTime dateTime={liveClass.dateTime} />
      {!!hasPreClassActivities && (
        <>
          <StyledHr />
          <CountdownWidgetContent
            title={__('getAheadOfClass')}
            description={__('warmUpWithPreActivitiesPreviewConcepts')}
            buttonText={__('startActivity')}
            preActivities={liveClass.preClassActivities}
          />
        </>
      )}
      <StyledHr />
      <ButtonWrapper>
        <Button
          variant="subtle"
          label={__('cancelClass')}
          onClick={() => setIsModalReservationCancelActive(true)}
        />
      </ButtonWrapper>
      <ModalReservationCancel
        show={isModalReservationCancelActive}
        onClose={() => setIsModalReservationCancelActive(false)}
        liveClass={liveClass}
      />
    </>
  );
};

const Title = styled.div`
  margin: 4px 0;
  font-family: 'Baloo 2';
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  color: ${({ theme }) => theme.colors.dark};
`;

const StyledHr = styled.hr`
  margin: 8px 0;
  border-bottom: 1px solid rgba(155, 155, 155, 0.21);
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
